import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private readonly keycloakService: KeycloakService) { }

  async login(): Promise<void> {
    try {
      await this.keycloakService.login({
        redirectUri: window.location.origin + '/#/main'
      });
    } catch (error) {
      // Login failed 
    }
  }

  async logout(): Promise<void> {
    try {
      await this.keycloakService.logout(window.location.origin);
    } catch (error) {
      // Logout failed
    }
  }

  isLoggedIn(): boolean {
    return this.keycloakService.isLoggedIn();
  }

  getUserProfile() {
    return this.keycloakService.getKeycloakInstance().profile;
  }

  async loadUserProfile() {
    try {
      return await this.keycloakService.loadUserProfile();
    } catch (error) {
      // Failed to load user profile
      return null;
    }
  }

  async getToken(): Promise<string> {
    return this.keycloakService.getToken();
  }

  getUserRoles(): string[] {
    return this.keycloakService.getUserRoles();
  }

  hasRole(role: string): boolean {
    return this.getUserRoles().includes(role);
  }
}
